import {Component, OnInit, signal} from '@angular/core';
import {IUserProfile, UserService} from '../../shared/services/user.service';
import {CommonModule} from '@angular/common';
import {
  AsyncValidatorFn,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators
} from '@angular/forms';
import {catchError, first, map, Observable, of} from 'rxjs';

@Component({
  selector: 'app-profile',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  userProfile = signal<IUserProfile | null>(null);

  usernameControl: FormControl = new FormControl('', {
    validators: [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9_.]{1,25}$/)
    ],
    asyncValidators: [this.usernameUniqueValidator()],
    updateOn: 'change'
  });

  constructor(public userService: UserService) {}

  ngOnInit(): void {
    this.userProfile.set(this.userService.userProfile());
    const user = this.userProfile();
    if (user) {
      this.usernameControl.setValue(user.name);
      this.usernameControl.updateValueAndValidity();
    }
  }

  updateUsername() {
    const user = this.userProfile();
    const newUsername = this.usernameControl.value;

    if (user && this.usernameControl.valid && newUsername !== user.name) {
      this.userService.updateProfile({ username: newUsername }).subscribe({
        next: () => {
          this.userService.userProfile.set({
            ...user,
            name: newUsername
          });
          console.log('Username updated!');
        },
        error: (err) => {

          console.error('Failed to update username', err);
        }
      });
    }
  }

  usernameUniqueValidator(): AsyncValidatorFn {
    return (control): Observable<ValidationErrors | null> => {
      if (!control.value) return of(null);

      const currentUsername = this.userProfile()?.name;
      const newUsername = control.value;

      if (newUsername === currentUsername) {
        return of(null);
      }

      return this.userService.checkUsername(newUsername).pipe(
        map((isAvailable: boolean) => (isAvailable ? null : { taken: true })),
        catchError(() => of<ValidationErrors | null>(null)),
        first()
      );
    };
  }
}
